import {GENERIC_ERROR_HAS_OCCURRED} from '../constants/action-types';
import {GENERIC_ERROR_TYPES} from '../../consts';

export const genericErrorHasOccurred = (genericError, genericErrorType = GENERIC_ERROR_TYPES.standard) => ({
    type: GENERIC_ERROR_HAS_OCCURRED,
    payload: {
        genericError,
        genericErrorType
    }
});
